import React, { useMemo } from 'react';
import { Cell } from 'react-table';
import dayjs from 'dayjs';
import { Row } from 'react-bootstrap';
import TableCommonV2 from 'Components/Common/Table/TableCommonV2';
import { DATE_FORMAT_CMT } from 'Constant/Date';

export default function TableSampleMasterDp({ dataSource }: { dataSource: any[] }): JSX.Element {
  const columns = useMemo(
    () => [
      {
        Header: '',
        accessor: 'empty',
        className: 'pe-none',
        columns: [
          {
            Header: '配布日時',
            accessor: 'createdAt',
            Cell: ({ row }: Cell<any>) => (
              <div className="text-truncate">
                {row?.original?.createdAt
                  ? dayjs(row?.original?.createdAt).format(DATE_FORMAT_CMT)
                  : ''}
              </div>
            ),
          },
          {
            Header: 'ユーザーID',
            accessor: 'miimID',
            width: '100',
            Cell: ({ row }: Cell<any>) => (
              <div className="text-truncate">{row?.original?.miimID}</div>
            ),
          },
          {
            Header: 'ユーザ名',
            accessor: 'userName',
            Cell: ({ row }: Cell<any>) => {
              return (
                <>
                  <div className="text-truncate">{row?.original?.realName}</div>
                </>
              );
            },
            sortType: (rowA: any, rowB: any, columnId: string, desc: boolean) => {
              const defaultVal = desc ? 'A' : 'Z';
              return (rowA?.original?.realName ?? defaultVal).localeCompare(
                rowB?.original?.realName ?? defaultVal,
              );
            },
          },
          {
            Header: 'メールアドレス',
            accessor: 'email',
            Cell: ({ row }: Cell<any>) => {
              return <div className="text-truncate">{row?.original?.email}</div>;
            },
            sortType: (rowA: any, rowB: any, columnId: string, desc: boolean) => {
              const defaultVal = desc ? 'A' : 'Z';
              return (rowA?.original?.email ?? defaultVal).localeCompare(
                rowB?.original?.email ?? defaultVal,
              );
            },
          },
        ],
      },
    ],
    [],
  );
  return (
    <Row className="mt-3 px-0 sample-master-table">
      <TableCommonV2
        data={dataSource}
        columns={columns}
        isNotShowSort={true}
        getCellProps={() => {
          return {
            className: 'text-start',
          };
        }}
        getHeaderProps={() => {
          return {
            className: 'text-white text-center d-flex align-item-center bg-dark',
          };
        }}
      />
    </Row>
  );
}
